import { useSortable } from '@dnd-kit/sortable';
import { Group, Paper, Switch, Text } from '@mantine/core';
import { IconGripVertical } from '@tabler/icons-react';
import { CSS } from "@dnd-kit/utilities";

const ColumnsContentItem = ({ column, checked, onCheck }) => {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id: column.id });

    return (
        <Paper
            component={Group}
            ref={setNodeRef}
            style={{
                transform: CSS.Transform.toString(transform),
                transition,
                zIndex: 10,
            }}
            radius={"md"}
            gap={"xs"}
            wrap="nowrap"
            mt={"xs"}
            py={2}
        >
            <IconGripVertical
                size={18}
                style={{ cursor: "grab", opacity: 0.5 }}
                {...attributes}
                {...listeners}
            />

            <Switch
                label={column.headerName}
                key={column.field}
                onChange={onCheck}
                checked={checked}
                size="sm"
            />
        </Paper>
    )
}

export default ColumnsContentItem